<template>
    <LaBaseTable data-test="alert-silence-table" :headers="headers" :items="data" stripped>
        <template #no-data>No silences - every alert is sent.</template>

        <template #item-alert_code="{ item }">
            <span v-if="item.alert_code">{{ item.alert_code }}</span>
            <span v-else class="muted">all types</span>
        </template>

        <template #item-matchers="{ item }">
            <div v-if="item.matchers && Object.keys(item.matchers).length">
                <code v-for="matcher in formatMatchers(item.matchers)" :key="matcher" class="matcher">
                    {{ matcher }}
                </code>
            </div>
            <span v-else class="muted">every alert</span>
        </template>

        <template #item-expires_at="{ item }">
            <div>
                <LaStatusLabel v-if="!item.active" type="info" label="expired" />
                <div v-if="item.expires_at">{{ formatDateTimePragueTimeZone(item.expires_at) }}</div>
                <div v-else>never</div>
            </div>
        </template>

        <template #item-created_at="{ item }">
            <div>
                <div>{{ item.created_by || "—" }}</div>
                <div class="muted">{{ formatDateTimePragueTimeZone(item.created_at) }}</div>
            </div>
        </template>

        <template #item-actions="{ item }">
            <LaActionIcon type="edit" title="Edit" data-test="edit-silence" @click="edit(item)" />
            <LaActionIcon type="delete" title="Delete" data-test="delete-silence" @click="remove(item)" />
        </template>
    </LaBaseTable>
</template>

<script>
import LaBaseTable from "@/components/BaseTable";
import LaStatusLabel from "@/components/StatusLabel";
import LaActionIcon from "@/components/button/ActionIcon";
import store from "@/store/store";
import { mutationTypes as dialogMutationTypes } from "@/store/Dialog/types";
import { formatDateTimePragueTimeZone } from "@/helpers/filters.js";
import { formatMatchers } from "@/components/alerts/helpers";

export default {
    name: "LaAlertSilenceTable",
    components: {
        LaBaseTable,
        LaStatusLabel,
        LaActionIcon,
    },
    props: {
        data: {
            required: true,
        },
    },
    computed: {
        headers() {
            return [
                { text: "type", value: "alert_code" },
                { text: "matches", value: "matchers", flex: "2", sortable: false },
                { text: "reason", value: "reason", flex: "2" },
                { text: "expires", value: "expires_at" },
                { text: "created", value: "created_at", direction: -1 },
                { text: "", value: "actions", sortable: false },
            ];
        },
    },
    setup() {
        const edit = (item) => {
            store.commit(dialogMutationTypes.openDialog, {
                dialogName: "alertSilenceForm",
                dialogHeading: "Edit silence",
                item,
            });
        };
        const remove = (item) => {
            store.commit(dialogMutationTypes.openDialog, {
                dialogName: "silenceDelete",
                dialogHeading: "Delete silence",
                item,
            });
        };

        return { edit, remove, formatMatchers, formatDateTimePragueTimeZone };
    },
};
</script>

<style lang="scss" scoped>
.muted {
    font-size: 0.8rem;
    opacity: 0.7;
}
.matcher {
    display: block;
    font-size: 0.8rem;
    background: none;
    padding: 0;
}
</style>
